<template>
  <div v-if="organisation" class="container">
    <PreviousNavLink go-to-link="/" previous-label="Tillbaka till Mina organisationer"></PreviousNavLink>
    <div class="row">
      <div class="col-lg-8">
        <h1 class="page-header">{{ organisation?.displayName }}</h1>
        <p class="intro">Här hittar du uppgifter om din organisation, dess avtal och tjänster med SPSM. Du kan teckna
          PUB-avtal och lägga till och ta bort organisationsadministratörer.</p>
      </div>
    </div>

    <div class="row mt-4 mb-5">
      <div class="col-lg-4">
        <div><b>Godkänd av SPSM
        </b></div>
        <div>{{ formatDateToDateTime(organisation?.startDate) }}</div>
        <br>
        <div><b>Organisationsnummer
        </b></div>
        <div>{{ organisation?.organisationNumber }}</div>
      </div>
      <div v-if="organisation?.addressList && organisation.addressList.length" class="col-lg-4">
        <div><b>Adress</b></div>
        <div>
          {{ organisation?.displayName }}<br />
          {{ organisation?.addressList[0]?.streetAddress }}<br />
          {{ organisation?.addressList[0]?.postalCode }} {{ organisation?.addressList[0]?.locality }}<br />
          {{ organisation?.phoneNumber }}
        </div>
      </div>
      <div v-if="organisation?.contactInfoList" class="col-lg-4">
        <div><b>Huvudkontakt
        </b></div>
        <div v-if="organisation?.contactInfoList">
          {{ organisation?.contactInfoList[0]?.firstName }} {{ organisation.contactInfoList[0]?.lastName
          }}<br />
          {{ organisation?.contactInfoList[0]?.email }}<br />
          {{ organisation?.contactInfoList[0]?.phone }}<br />
        </div>
      </div>
    </div>

    <h3 class="h4">Avtal och tjänster</h3>
    <TableAgreementAndServices />
    <h3 class="h4 mt-5">Organisationsadministratörer</h3>
    <TableAdministrators />
    <div class="mt-5 buttons-container spread-buttons">
      <PreviousNavLink go-to-link="/" previous-label="Tillbaka till Mina organisationer"></PreviousNavLink>
      <router-link :to="'/organisation/' + orgId + '/anvandare/'" class="btn btn-light float-right">Lägg till
        organisationsadministratör +
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import TableAgreementAndServices from "../components/TableAgreementAndServices.vue";
import TableAdministrators from "../components/TableAdministrators.vue";
import Symbol from "../components/Symbol.vue";
import { useOrganisationStore } from "@/stores/organisation";
import { storeToRefs } from "pinia";
import { OrganisationModel } from "@Shared/Models/OrganisationModel";
import { computed, watchEffect } from "vue";
import { formatDateToDateTime } from "@/helper/dateFormat";
import { useOrganisationUsersStore } from "@/stores/organisationUsers";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

export default defineComponent({
    name: "OrgDetailView",
    components: {
        PreviousNavLink,
        TableAgreementAndServices,
        TableAdministrators,
        Symbol
    },
    setup() {
        const headers = [
            { field: "id", name: "Id", visible: false },
            { field: "type", name: "Typ", visible: true },
            { field: "name", name: "Namn", visible: true },
            { field: "status", name: "Status", visible: true },
            { field: "icon", name: "Icon", visible: false }
        ];
        const router = useRouter();
        const route = useRoute();
        const { orgId } = route.params;
        const organisationStore = useOrganisationStore();
        const organisationUsersStore = useOrganisationUsersStore();
        const { pubAgreement } = storeToRefs(organisationStore);
        console.log("getting organisation");
        // Define a computed property for the organization
        const organisation = computed(() => organisationStore.getOrganisationById(orgId as string) as OrganisationModel);

        let hasLoaded = false;

        watchEffect(async () => {
            if (organisation.value && !hasLoaded) {
                hasLoaded = true;

                const id = orgId as string;

                // 1. hämta services (för isResign)
                await organisationStore.GetOrgServicesAndAgreements(id);
                await organisationStore.GetPubAgreements(id, false);
                await organisationUsersStore.GetAllOrgUsers(id);
            }

            else if (!organisation.value) {
                router.push({
                    name: 'organisationNotFound',
                    params: { orgId }
                });
            }
        });

        return {
            headers,
            organisation,
            pubAgreement,
            orgId,
            formatDateToDateTime
        };
    }
});
</script>

<style lang="scss">
</style>